export const actEnglishWorksheets = [
  // CONVENTIONS OF STANDARD ENGLISH - PUNCTUATION (7 worksheets)
  {
    id: 'act-eng-punctuation-commas-essential',
    title: 'Commas with Essential vs. Non-Essential Elements',
    description: 'Master comma placement with restrictive and non-restrictive clauses, appositives, and parenthetical elements',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Punctuation',
    pages: 4,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-punctuation-commas-essential.pdf',
    thumbnailUrl: 'https://public.readdy.ai/ai/img_res/24286c6607b595db0fa52f96fbd417c6.jpg'
  },
  {
    id: 'act-eng-punctuation-commas-series',
    title: 'Commas in Series and Lists',
    description: 'Practice using commas correctly in lists, series, and coordinate adjectives',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Punctuation',
    pages: 3,
    difficulty: 'Beginner' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-punctuation-commas-series.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=educational%20worksheet%20with%20list%20items%20and%20comma%20punctuation%20examples%20clean%20white%20background%20with%20emerald%20green%20highlights%20modern%20academic%20design&width=400&height=300&seq=actenglishcommas2&orientation=landscape'
  },
  {
    id: 'act-eng-punctuation-semicolons-colons',
    title: 'Semicolons and Colons',
    description: 'Learn when to use semicolons to join independent clauses and colons to introduce lists or explanations',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Punctuation',
    pages: 4,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-punctuation-semicolons-colons.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=minimalist%20worksheet%20design%20featuring%20semicolon%20and%20colon%20punctuation%20marks%20with%20sentence%20examples%20white%20background%20emerald%20teal%20color%20scheme%20professional%20educational%20style&width=400&height=300&seq=actenglishsemicolon&orientation=landscape'
  },
  {
    id: 'act-eng-punctuation-apostrophes',
    title: 'Apostrophes for Possession and Contractions',
    description: 'Master apostrophe usage in possessive nouns, contractions, and common errors like its vs. it\'s',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Punctuation',
    pages: 3,
    difficulty: 'Beginner' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-punctuation-apostrophes.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=clean%20educational%20worksheet%20showing%20apostrophe%20punctuation%20with%20possessive%20nouns%20and%20contractions%20white%20background%20soft%20green%20accents%20modern%20academic%20layout&width=400&height=300&seq=actenglishapostrophe&orientation=landscape'
  },
  {
    id: 'act-eng-punctuation-dashes-parentheses',
    title: 'Dashes and Parentheses',
    description: 'Practice using em dashes and parentheses to set off additional information or create emphasis',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Punctuation',
    pages: 3,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-punctuation-dashes-parentheses.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=minimalist%20worksheet%20design%20with%20dash%20and%20parentheses%20punctuation%20marks%20sentence%20examples%20white%20background%20emerald%20green%20color%20accents%20professional%20educational%20style&width=400&height=300&seq=actenglishdashes&orientation=landscape'
  },
  {
    id: 'act-eng-punctuation-end-marks',
    title: 'End-of-Sentence Punctuation',
    description: 'Review proper use of periods, question marks, and exclamation points in various contexts',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Punctuation',
    pages: 2,
    difficulty: 'Beginner' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-punctuation-end-marks.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=clean%20educational%20worksheet%20showing%20period%20question%20mark%20exclamation%20point%20punctuation%20white%20background%20with%20teal%20green%20highlights%20modern%20academic%20design&width=400&height=300&seq=actenglishendmarks&orientation=landscape'
  },
  {
    id: 'act-eng-punctuation-comprehensive',
    title: 'Comprehensive Punctuation Review',
    description: 'Mixed practice covering all punctuation marks tested on the ACT English section',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Punctuation',
    pages: 5,
    difficulty: 'Advanced' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-punctuation-comprehensive.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=comprehensive%20punctuation%20worksheet%20with%20multiple%20punctuation%20marks%20and%20sentence%20examples%20white%20background%20emerald%20teal%20gradient%20accents%20professional%20educational%20layout&width=400&height=300&seq=actenglishpunctcomp&orientation=landscape'
  },

  // CONVENTIONS OF STANDARD ENGLISH - GRAMMAR & USAGE (8 worksheets)
  {
    id: 'act-eng-grammar-subject-verb',
    title: 'Subject-Verb Agreement',
    description: 'Practice matching subjects with verbs, including tricky cases with prepositional phrases and compound subjects',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Grammar and Usage',
    pages: 4,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-grammar-subject-verb.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=educational%20grammar%20worksheet%20showing%20subject%20and%20verb%20agreement%20with%20sentence%20diagrams%20white%20background%20emerald%20green%20accents%20clean%20modern%20academic%20style&width=400&height=300&seq=actenglishsubverb&orientation=landscape'
  },
  {
    id: 'act-eng-grammar-pronoun-antecedent',
    title: 'Pronoun-Antecedent Agreement',
    description: 'Master pronoun agreement in number, gender, and person with their antecedents',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Grammar and Usage',
    pages: 4,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-grammar-pronoun-antecedent.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=clean%20grammar%20worksheet%20with%20pronouns%20and%20antecedents%20connected%20by%20arrows%20white%20background%20soft%20teal%20green%20color%20scheme%20professional%20educational%20design&width=400&height=300&seq=actenglishpronoun1&orientation=landscape'
  },
  {
    id: 'act-eng-grammar-verb-tense',
    title: 'Verb Tense and Formation',
    description: 'Practice maintaining consistent verb tense and using correct verb forms including irregular verbs',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Grammar and Usage',
    pages: 4,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-grammar-verb-tense.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=educational%20worksheet%20showing%20verb%20tenses%20timeline%20with%20past%20present%20future%20examples%20white%20background%20emerald%20green%20highlights%20modern%20academic%20layout&width=400&height=300&seq=actenglishverbtense&orientation=landscape'
  },
  {
    id: 'act-eng-grammar-pronoun-case',
    title: 'Pronoun Case',
    description: 'Learn when to use subjective, objective, and possessive pronoun forms (I vs. me, who vs. whom)',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Grammar and Usage',
    pages: 3,
    difficulty: 'Advanced' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-grammar-pronoun-case.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=minimalist%20grammar%20worksheet%20with%20pronoun%20case%20examples%20showing%20subjective%20objective%20possessive%20forms%20white%20background%20teal%20emerald%20accents%20professional%20style&width=400&height=300&seq=actenglishpronoun2&orientation=landscape'
  },
  {
    id: 'act-eng-grammar-modifiers',
    title: 'Adjectives, Adverbs, and Modifiers',
    description: 'Practice using adjectives vs. adverbs correctly and fixing misplaced or dangling modifiers',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Grammar and Usage',
    pages: 4,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-grammar-modifiers.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=clean%20educational%20worksheet%20showing%20adjectives%20and%20adverbs%20modifying%20words%20with%20arrows%20white%20background%20emerald%20green%20color%20scheme%20modern%20academic%20design&width=400&height=300&seq=actenglishmodifiers&orientation=landscape'
  },
  {
    id: 'act-eng-grammar-comparatives',
    title: 'Comparative and Superlative Forms',
    description: 'Master the correct use of comparative (-er, more) and superlative (-est, most) forms',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Grammar and Usage',
    pages: 3,
    difficulty: 'Beginner' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-grammar-comparatives.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=educational%20worksheet%20with%20comparative%20and%20superlative%20adjective%20examples%20good%20better%20best%20white%20background%20soft%20teal%20green%20accents%20professional%20layout&width=400&height=300&seq=actenglishcomparative&orientation=landscape'
  },
  {
    id: 'act-eng-grammar-idioms',
    title: 'Idiomatic Usage and Prepositions',
    description: 'Practice choosing the correct prepositions and idiomatic expressions commonly tested on the ACT',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Grammar and Usage',
    pages: 3,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-grammar-idioms.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=minimalist%20grammar%20worksheet%20showing%20prepositional%20phrases%20and%20idiomatic%20expressions%20white%20background%20emerald%20teal%20color%20highlights%20clean%20academic%20style&width=400&height=300&seq=actenglishidioms&orientation=landscape'
  },
  {
    id: 'act-eng-grammar-comprehensive',
    title: 'Comprehensive Grammar and Usage Review',
    description: 'Mixed practice covering all grammar and usage concepts tested on the ACT English section',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Grammar and Usage',
    pages: 6,
    difficulty: 'Advanced' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-grammar-comprehensive.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=comprehensive%20grammar%20worksheet%20with%20multiple%20grammar%20concepts%20and%20sentence%20examples%20white%20background%20emerald%20green%20gradient%20accents%20professional%20educational%20design&width=400&height=300&seq=actenglishgrammarcomp&orientation=landscape'
  },

  // CONVENTIONS OF STANDARD ENGLISH - SENTENCE STRUCTURE (6 worksheets)
  {
    id: 'act-eng-structure-fragments',
    title: 'Sentence Fragments',
    description: 'Identify and correct incomplete sentences that lack a subject, verb, or complete thought',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Sentence Structure',
    pages: 3,
    difficulty: 'Beginner' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-structure-fragments.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=educational%20worksheet%20showing%20sentence%20fragments%20and%20complete%20sentences%20with%20visual%20diagrams%20white%20background%20emerald%20green%20accents%20modern%20academic%20style&width=400&height=300&seq=actenglishfragments&orientation=landscape'
  },
  {
    id: 'act-eng-structure-run-ons',
    title: 'Run-On Sentences and Fused Sentences',
    description: 'Learn to identify and fix run-on sentences where two independent clauses are improperly joined',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Sentence Structure',
    pages: 4,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-structure-run-ons.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=clean%20grammar%20worksheet%20with%20run%20on%20sentences%20and%20correction%20methods%20white%20background%20soft%20teal%20green%20color%20scheme%20professional%20educational%20layout&width=400&height=300&seq=actenglishrunons&orientation=landscape'
  },
  {
    id: 'act-eng-structure-comma-splices',
    title: 'Comma Splices',
    description: 'Practice identifying and correcting comma splices where commas incorrectly join independent clauses',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Sentence Structure',
    pages: 3,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-structure-comma-splices.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=minimalist%20worksheet%20showing%20comma%20splice%20errors%20and%20corrections%20with%20sentence%20examples%20white%20background%20emerald%20teal%20accents%20clean%20academic%20design&width=400&height=300&seq=actenglishcommasplice&orientation=landscape'
  },
  {
    id: 'act-eng-structure-coordination',
    title: 'Coordination and Subordination',
    description: 'Master the use of coordinating and subordinating conjunctions to join clauses properly',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Sentence Structure',
    pages: 4,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-structure-coordination.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=educational%20worksheet%20with%20coordinating%20and%20subordinating%20conjunctions%20connecting%20clauses%20white%20background%20emerald%20green%20highlights%20modern%20professional%20style&width=400&height=300&seq=actenglishcoordination&orientation=landscape'
  },
  {
    id: 'act-eng-structure-parallelism',
    title: 'Parallel Structure',
    description: 'Practice maintaining parallel structure in lists, comparisons, and paired elements',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Sentence Structure',
    pages: 4,
    difficulty: 'Advanced' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-structure-parallelism.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=clean%20grammar%20worksheet%20showing%20parallel%20structure%20with%20balanced%20sentence%20elements%20and%20lists%20white%20background%20teal%20emerald%20color%20scheme%20academic%20layout&width=400&height=300&seq=actenglishparallel&orientation=landscape'
  },
  {
    id: 'act-eng-structure-comprehensive',
    title: 'Comprehensive Sentence Structure Review',
    description: 'Mixed practice covering fragments, run-ons, comma splices, coordination, and parallelism',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Sentence Structure',
    pages: 5,
    difficulty: 'Advanced' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-structure-comprehensive.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=comprehensive%20sentence%20structure%20worksheet%20with%20multiple%20grammar%20concepts%20and%20examples%20white%20background%20emerald%20green%20gradient%20professional%20educational%20design&width=400&height=300&seq=actenglishstructcomp&orientation=landscape'
  },

  // PRODUCTION OF WRITING - RHETORICAL SKILLS (5 worksheets)
  {
    id: 'act-eng-rhetorical-topic-development',
    title: 'Topic Development and Strategy',
    description: 'Practice deciding whether to add, delete, or revise sentences based on the passage\'s purpose and focus',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Rhetorical Skills',
    pages: 4,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-rhetorical-topic-development.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=educational%20worksheet%20showing%20essay%20topic%20development%20with%20main%20ideas%20and%20supporting%20details%20white%20background%20emerald%20teal%20accents%20modern%20academic%20style&width=400&height=300&seq=actenglishtopicdevel&orientation=landscape'
  },
  {
    id: 'act-eng-rhetorical-organization',
    title: 'Organization and Logical Sequence',
    description: 'Learn to arrange sentences and paragraphs in the most logical and effective order',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Rhetorical Skills',
    pages: 4,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-rhetorical-organization.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=clean%20worksheet%20with%20paragraph%20organization%20and%20sentence%20ordering%20diagrams%20white%20background%20soft%20emerald%20green%20color%20scheme%20professional%20educational%20layout&width=400&height=300&seq=actenglishorganization&orientation=landscape'
  },
  {
    id: 'act-eng-rhetorical-transitions',
    title: 'Transitions and Coherence',
    description: 'Master the use of transitional words and phrases to connect ideas smoothly within and between paragraphs',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Rhetorical Skills',
    pages: 3,
    difficulty: 'Beginner' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-rhetorical-transitions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=minimalist%20worksheet%20showing%20transition%20words%20connecting%20paragraphs%20and%20ideas%20white%20background%20emerald%20teal%20highlights%20clean%20academic%20design&width=400&height=300&seq=actenglishTransitions&orientation=landscape'
  },
  {
    id: 'act-eng-rhetorical-unity',
    title: 'Unity and Focus',
    description: 'Practice maintaining a consistent focus and identifying sentences that disrupt the passage\'s unity',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Rhetorical Skills',
    pages: 3,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-rhetorical-unity.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=educational%20worksheet%20with%20essay%20unity%20and%20focus%20concepts%20showing%20main%20theme%20consistency%20white%20background%20emerald%20green%20accents%20modern%20professional%20style&width=400&height=300&seq=actenglishunity&orientation=landscape'
  },
  {
    id: 'act-eng-rhetorical-comprehensive',
    title: 'Comprehensive Rhetorical Skills Review',
    description: 'Mixed practice covering topic development, organization, transitions, and unity',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Rhetorical Skills',
    pages: 5,
    difficulty: 'Advanced' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-rhetorical-comprehensive.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=comprehensive%20rhetorical%20skills%20worksheet%20with%20essay%20organization%20and%20development%20concepts%20white%20background%20emerald%20teal%20gradient%20academic%20layout&width=400&height=300&seq=actenglishrhetcomp&orientation=landscape'
  },

  // KNOWLEDGE OF LANGUAGE - WORD CHOICE (5 worksheets)
  {
    id: 'act-eng-wordchoice-precision',
    title: 'Precise Word Choice and Diction',
    description: 'Practice selecting the most accurate and appropriate word for a given context',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Word Choice and Style',
    pages: 3,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-wordchoice-precision.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=clean%20educational%20worksheet%20showing%20word%20choice%20and%20vocabulary%20precision%20with%20synonym%20examples%20white%20background%20emerald%20green%20accents%20modern%20academic%20style&width=400&height=300&seq=actenglishprecision&orientation=landscape'
  },
  {
    id: 'act-eng-wordchoice-conciseness',
    title: 'Conciseness and Eliminating Wordiness',
    description: 'Learn to choose the shortest, clearest option that conveys the necessary information',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Word Choice and Style',
    pages: 4,
    difficulty: 'Beginner' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-wordchoice-conciseness.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=minimalist%20worksheet%20with%20wordy%20sentences%20and%20concise%20revisions%20side%20by%20side%20white%20background%20soft%20teal%20green%20color%20scheme%20professional%20layout&width=400&height=300&seq=actenglishconcise&orientation=landscape'
  },
  {
    id: 'act-eng-wordchoice-redundancy',
    title: 'Eliminating Redundancy',
    description: 'Practice identifying and removing redundant words and phrases that repeat the same idea',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Word Choice and Style',
    pages: 3,
    difficulty: 'Beginner' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-wordchoice-redundancy.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=educational%20worksheet%20showing%20redundant%20phrases%20crossed%20out%20with%20better%20alternatives%20white%20background%20emerald%20teal%20highlights%20clean%20academic%20design&width=400&height=300&seq=actenglishredundancy&orientation=landscape'
  },
  {
    id: 'act-eng-wordchoice-tone',
    title: 'Tone and Style Consistency',
    description: 'Master maintaining a consistent level of formality and matching the author\'s established tone',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Word Choice and Style',
    pages: 3,
    difficulty: 'Intermediate' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-wordchoice-tone.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=clean%20worksheet%20with%20formal%20and%20informal%20tone%20examples%20showing%20style%20consistency%20white%20background%20emerald%20green%20accents%20modern%20professional%20style&width=400&height=300&seq=actenglishTone&orientation=landscape'
  },
  {
    id: 'act-eng-wordchoice-comprehensive',
    title: 'Comprehensive Word Choice Review',
    description: 'Mixed practice covering precision, conciseness, redundancy elimination, and tone consistency',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Word Choice and Style',
    pages: 4,
    difficulty: 'Advanced' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-wordchoice-comprehensive.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=comprehensive%20word%20choice%20worksheet%20with%20multiple%20style%20and%20diction%20concepts%20white%20background%20emerald%20teal%20gradient%20accents%20academic%20layout&width=400&height=300&seq=actenglishwordcomp&orientation=landscape'
  },

  // FULL PRACTICE SETS (3 worksheets)
  {
    id: 'act-eng-full-practice-1',
    title: 'Full ACT English Practice Test 1',
    description: 'Complete 75-question practice test with 5 passages covering all ACT English topics (45-minute timed)',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Full Practice',
    pages: 12,
    difficulty: 'Advanced' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-full-practice-1.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=comprehensive%20ACT%20English%20practice%20test%20cover%20page%20with%20multiple%20passages%20and%20questions%20white%20background%20emerald%20green%20header%20professional%20test%20format&width=400&height=300&seq=actenglishfull1&orientation=landscape'
  },
  {
    id: 'act-eng-full-practice-2',
    title: 'Full ACT English Practice Test 2',
    description: 'Complete 75-question practice test with 5 passages covering all ACT English topics (45-minute timed)',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Full Practice',
    pages: 12,
    difficulty: 'Advanced' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-full-practice-2.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=professional%20ACT%20English%20practice%20exam%20layout%20with%20reading%20passages%20and%20multiple%20choice%20questions%20white%20background%20teal%20emerald%20accents%20academic%20test%20design&width=400&height=300&seq=actenglishfull2&orientation=landscape'
  },
  {
    id: 'act-eng-full-practice-3',
    title: 'Full ACT English Practice Test 3',
    description: 'Complete 75-question practice test with 5 passages covering all ACT English topics (45-minute timed)',
    grade: 'ACT English',
    subject: 'Test Prep',
    topic: 'Full Practice',
    pages: 12,
    difficulty: 'Advanced' as const,
    isFree: false,
    downloadUrl: '/downloads/act-eng-full-practice-3.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=clean%20ACT%20English%20standardized%20test%20format%20with%20passages%20and%20answer%20bubbles%20white%20background%20emerald%20green%20branding%20professional%20academic%20style&width=400&height=300&seq=actenglishfull3&orientation=landscape'
  }
];